import vars from '../root';
import {Platform, Pressable} from 'react-native';
import styled from 'styled-components';

const style = {
  textAlign: 'center',
  // color: vars.WHITE,
  // backgroundColor: porps => porps.theme.components.button.colors.primary,
  backgroundColor: ({theme}) => theme.colors.primary,
  color: ({theme}) => theme.colors.text.primary,
  borderRadius: 4,
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 15,
  paddingRight: 15,
  alignSelf: vars.alignSelfRev,
};

const CommonButtonStyleAndroid = {
  ...style,
  fontSize: 24,
  width: '50%',
};

const CommonButtonStyleWeb = {
  ...style,
  textAlign: 'center',
  margin: 10,
  fontSize: '16px',
  // fontSize: 24,
  // width: '50%',
  // float: 'right',
  // clear: 'both',
  border: 'none',
  cursor: 'pointer',
};

export const CommonButtonTextStyleAndroid = {
  textAlign: 'center',
  color: vars.WHITE,
  fontSize: 20,
};
export const CommonButtonTextStyleWebPhone = {
  textAlign: 'center',
  color: vars.WHITE,
  fontSize: 14,
  fontFamily: 'IRANSans',
  whiteSpace: 'nowrap',
  paddingLeft: 20,
  paddingRight: 20,
};

export const CommonButtonTextStyleWeb = {
  textAlign: 'center',
  color: vars.WHITE,
  fontSize: 14,
  fontFamily: 'IRANSans',
  whiteSpace: 'nowrap',
  paddingLeft: undefined,
  paddingRight: undefined,
};
export const justifyContentEnd = {
  justifyContent: 'end',
};

export const Button =
  Platform.OS === 'android' || Platform.OS === 'ios'
    ? styled(Pressable)`
        ${CommonButtonStyleAndroid}
      `
    : styled.button`
        ${CommonButtonStyleWeb}
      `;

const TransparentButtonStyle = {
  borderWidth: 1,
  borderStyle: 'solid',
};

export const chooseTheme = (color, allStyles, textStyle, theme, varient) => {
  const backgroundColor =
    varient === 'outline' ||
    varient === 'text' ||
    color.indexOf('transparent') !== -1
      ? 'transparent'
      : color === 'primary'
      ? theme.name === 'dark'
        ? vars.COLOR_PRIMARY
        : vars.LIGHT_COLOR_PRIMARY
      : color === 'success'
      ? theme.name === 'dark'
        ? vars.COLOR_SUCCESS
        : vars.LIGHT_COLOR_SUCCESS
      : color === 'yellow'
      ? theme.name === 'dark'
        ? vars.COLOR_NEUTRAL
        : // : vars.LIGHT_COLOR_NEUTRAL
          vars.COLOR_ACCENT
      : color === 'cream'
      ? vars.CREAM
      : color === 'green'
      ? vars.GREEN
      : color === 'orangeRed'
      ? vars.ORANGE_RED
      : theme.name === 'dark'
      ? theme.colors.background.btn
      : vars.DARK_BLUE;
  allStyles.backgroundColor = backgroundColor;

  const calcedColor =
    color === 'primary'
      ? theme.name === 'dark'
        ? vars.COLOR_PRIMARY
        : vars.LIGHT_COLOR_PRIMARY
      : color === 'primary'
      ? theme.name === 'success'
        ? vars.COLOR_SUCCESS
        : vars.LIGHT_COLOR_SUCCESS
      : color === 'yellow'
      ? vars.DARK_THEME_LEVEL1
      : color === 'cream'
      ? vars.DARK_BLUE
      : color === 'green'
      ? vars.GREEN
      : color === 'orangeRed'
      ? vars.ORANGE_RED
      : theme.name === 'dark'
      ? theme.colors.background.btn
      : vars.DARK_BLUE;

  if (backgroundColor === 'transparent' || color === 'cream') {
    // className = 'myTransparentBtn';
    allStyles = {
      ...allStyles,
      ...TransparentButtonStyle,
      ...{
        borderColor: calcedColor,
      },
    };
    textStyle = {
      ...textStyle,
      ...{
        color: calcedColor,
      },
    };
  } else if (color === 'yellow-transparent') {
    allStyles = {
      ...allStyles,
      ...TransparentButtonStyle,
      ...{
        borderColor:
          theme.name === 'dark'
            ? vars.COLOR_BASE_CONTENT
            : vars.LIGHT_COLOR_BASE_CONTENT,
      },
    };
    textStyle = {
      ...textStyle,
      ...{
        color:
          theme.name === 'dark'
            ? vars.COLOR_BASE_CONTENT
            : vars.LIGHT_COLOR_BASE_CONTENT,
      },
    };
  }
  return [allStyles, textStyle];
};
